
import { Tag } from 'ant-design-vue';
import {
  computed, defineAsyncComponent, defineComponent, inject,
} from 'vue';
import { questionTypes } from '@/views/Teacher/addJob/question/js/index';
import useAnalysisHooks from '@/hooks/analysis.hooks';
// import Mock from '@/mock';

const question = ['single', 'multiple', 'true-false', 'blank'];
const option = ['A', 'B', 'C', 'D', 'E', 'F'];
export default defineComponent({
  components: {
    aTag: Tag,
    blank: defineAsyncComponent(() => import('./blank.vue')),
    multiple: defineAsyncComponent(() => import('./multiple.vue')),
    single: defineAsyncComponent(() => import('./single.vue')),
    trueFalse: defineAsyncComponent(() => import('./trueOrFalse.vue')),
    resultCard: defineAsyncComponent(() => import('../resultCard.vue')),
  },
  props: {
    /** 题目 */
    questionTitle: {
      type: String,
      default: '题目内容',
    },
    /** 题干 —— api */
    stem: {
      type: String,
    },
    /** 题目id */
    id: {
      type: String,
      required: true,
    },
    /** 类型 */
    questionType: {
      type: Number,
      default: 0, //  0-单选题, 1-多选题,2-判断题,3-问答题 ,
    },
    /** 题号 */
    seq: {
      type: Number,
      default: 1,
    },
    /** 题目总分 */
    score: {
      type: Number,
      default: 10,
    },
    /** 解析 */
    analysis: {
      type: String,
      default: '',
    },
    /** ========= */
    /** 学生选的答案 */
    stuAnswer: {
      required: false,
    },
    pStuAnswer: {
      type: Array,
      default: () => [],
    },
    /** 有没有做对 */
    stuTrue: {
      type: Boolean,
      default: true,
    },
    /** 学生得到分数 */
    stuScore: {
      type: Number,
      default: 0,
    },
    /** 选项 */
    pMetas: {
      type: Array,
      default: () => [],
    },
    /** 正确答案 */
    pAnswer: {
      type: Array,
      default: () => [],
    },
    /** 教师评分状态 */
    blankNumber: {
      type: Number,
    },
  },
  emits: ['reload'],
  setup(props, { emit }) {
    const analysisHooks = useAnalysisHooks();
    const jobView = inject('jobView');
    const assignmentId = inject<string>('assignmentId')!;
    const assignmentModel = inject('assignmentModel');
    /** 用来传参的——正确答案 */
    const vAnswer = computed(() => {
      if (props.questionType === 0) return props.pAnswer[0] as number * 1; // number
      if (props.questionType === 1) return props.pAnswer.map((a) => a as number * 1).sort(); // number[]
      if (props.questionType === 2) return !!props.pAnswer[0] as boolean; // boolean
      if (props.questionType === 3) return `<div>${props.pAnswer}</div>`;
      return '';
    });
    /** 用来传参的——stu答案 */
    const vStuAnswer = computed(() => {
      if (props.questionType === 0) return props.pStuAnswer[0]; // number | undefined
      if (props.questionType === 1) return props.pStuAnswer.map((a) => a as number * 1).sort(); // number[] | number
      if (props.questionType === 2) return props.pStuAnswer[0]; // boolean | undefined
      if (props.questionType === 3) return `${props.pStuAnswer}`;
      return '';
    });
    /** 用来显示的 */
    const answerText = computed(() => {
      if (props.questionType === 0) return option[props.pAnswer[0] as number]; // A
      if (props.questionType === 1) return props.pAnswer.map((a) => option[a as number]).sort().join('、'); // A、B
      if (props.questionType === 2) return props.pAnswer[0] ? '正确' : '错误'; //
      if (props.questionType === 3) return `<div>${props.pAnswer}</div>`;
      return '';
    });
    /** 学生的回答 */
    // const stuAnswer = computed(()=>props.stuAnswer);
    /** 保存答案 */
    const saveStuAnswer = (data: unknown) => {
      const count = assignmentModel === '1' ? 1 : 1; // 如果是考核模式，则一直是1。自由模式向上累加
      // console.log(assignmentId, props.id, count, data);
      analysisHooks.saveStuAnswer(assignmentId, props.id, count, JSON.stringify(data));
    };
    /** card-model——教师的查看可以更改问答题分数 */
    const cardModel = computed(() => {
      if (jobView === 'see') return inject('userRole') === 'student' ? 'stuSee' : 'teaSee';
      return jobView;
    });
    /** 通知父页面-刷新questionList */
    const reloadQuestion = () => {
      emit('reload');
    };
    return {
      jobView,
      questionTypes,
      vAnswer,
      vStuAnswer,
      answerText,
      question,
      // stuAnswer,
      // result-card部分
      cardModel,
      //
      saveStuAnswer,
      reloadQuestion,
    };
  },
});
